import React from 'react';
import ViewBeneficiaryReimbursement from '../../components/BeneficiaryReimbursement/ViewBeneficiaryReimbursement';

export default function ViewBeneficiaryReimbursementPage() {
    return (
        <div>
            <ViewBeneficiaryReimbursement />
        </div>
    )
}